// extracted by mini-css-extract-plugin
module.exports = {"section-wrapper":"_32ysB","title":"_3xpEO","levels-wrapper":"_3wDtc","level":"_1kqSd","level-img":"_3mGCJ","level-title":"aQZJs","selected":"_2OLhJ"};